import { render } from "./WhoPage.vue?vue&type=template&id=734388b5&scoped=true"
import script from "./WhoPage.vue?vue&type=script&lang=js"
export * from "./WhoPage.vue?vue&type=script&lang=js"

import "./WhoPage.vue?vue&type=style&index=0&id=734388b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734388b5"]])

export default __exports__